import { render } from "./quality-faq.vue?vue&type=template&id=fd70c4ac&scoped=true"
import script from "./quality-faq.vue?vue&type=script&lang=js"
export * from "./quality-faq.vue?vue&type=script&lang=js"

import "./quality-faq.vue?vue&type=style&index=0&id=fd70c4ac&scoped=true&lang=css"
import "./quality-faq.vue?vue&type=style&index=1&id=fd70c4ac&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd70c4ac"]])

export default __exports__